import { TAG } from "../constants";
import {
  GetNextPlaceParams,
  OnlineVisit,
  OnlineVisitBase,
  VisitType,
} from "../types";
import { patientApi } from "./patientApi";

export const visitApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getVisit: builder.query<OnlineVisit, string>({
      query: (visitId) => ({
        url: `/api/patient/visits/${visitId}`,
        method: "GET",
      }),

      providesTags: (_returns, _error, args) => [
        { type: TAG.ONLINE_VISITS, id: args },
      ],
    }),
    createVisit: builder.mutation<
      OnlineVisit,
      {
        product: string;
        visit_type?: VisitType;
        titration?: string;
        metadata?: Record<string, unknown>;
      }
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/patient/visits",
        body,
      }),
      invalidatesTags: [TAG.ONLINE_VISIT, TAG.ONLINE_VISITS],
    }),
    updateVisit: builder.mutation<
      OnlineVisit,
      { slug: string; data: Partial<OnlineVisit & { stripe_price_id: string }> }
    >({
      query: ({ slug, data }) => ({
        method: "PUT",
        url: `/api/patient/visits/${slug}`,
        body: data,
      }),
      onQueryStarted: (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          visitApi.util.updateQueryData("getVisit", args.slug, (draft) => {
            Object.assign(draft, args.data);
          }),
        );
        queryFulfilled.catch(patch.undo);
      },
      invalidatesTags: [TAG.USER, TAG.PAYMENT_METHODS],
    }),
    getVisitsList: builder.query<OnlineVisit[], void>({
      query: () => ({
        method: "GET",
        url: "/api/patient/visits/list",
      }),
      providesTags: [TAG.ONLINE_VISITS],
    }),
    getIncompleteVisit: builder.query<OnlineVisit, GetNextPlaceParams>({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/visits`,
        params,
      }),
      providesTags: [TAG.ONLINE_VISIT],
    }),
    getLatestVisits: builder.query<OnlineVisitBase[], void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/visits/latest`,
      }),
      providesTags: [TAG.ONLINE_VISITS],
    }),
  }),
});

export const {
  useCreateVisitMutation,
  useUpdateVisitMutation,
  useGetVisitQuery,
  useGetVisitsListQuery,
  useGetIncompleteVisitQuery,
  useGetLatestVisitsQuery,
} = visitApi;
